/*
 * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: MIT
 *
 * Licensed under the MIT License. See the LICENSE accompanying this file
 * for the specific language governing permissions and limitations under
 * the License.
 */

import React, { useEffect, useRef} from "react";
// import axios from 'axios';
// import { Auth } from 'aws-amplify';
// import { eraseCookie } from '../../components/LandingPage/helpers/cookieHelper';

class FormPost extends React.Component {
	constructor(props) {
		super(props);

		const queryParams = new URLSearchParams(window.location.search);

		this.forceAuth = queryParams.get("forceAuth") || false;
		this.code = queryParams.get("code") || false;
		this.scope =
			queryParams.get("scope") || "openid ticketing full_profile forced";
		// this.state = queryParams.get("state") || ""   //"act=login&amp;next="
		this.state = "act=login&next=";

		//needs to be generated
		this.sessionState =
			"TqVcrg8MF_fB0z6KzMaRm7g8AM4UC2d9iY88eWXxjEQ.D3EB6B120C72A788EF942E36B4BAC27D";

		// console.log(`search_params: ${window.location.search}`)

	}

	render() {
		return (
			<div>
				<form
					method="post"
					action="https://ticketing.lfcdev.com/idmSso"
				>
					<input
						// type="hidden"
						name="code"
						value={this.code}
					/>
					<input
						// type="hidden"
						name="scope"
						value={this.scope}
					/>
					<input
						//  type="hidden"
						name="state"
						value={this.state}
					/>
					<input
						// type="hidden"
						name="session_state"
						value={this.sessionState}
					/>
					<input id="submitInput" type="submit" />
				</form>
				</div>
		);
	}
}

export default FormPost;
